export default __webpack_public_path__ + "static/media/ios.25db3702.png";